module.exports = __webpack_public_path__ + "img/cc_parallax.6b9fc094.jpg";